// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.loading-wrapper[data-v-d1aa70fe] {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 2;\n}\n.swap-tree-image-wrapper[data-v-d1aa70fe] {\n  text-align: center;\n}\n.image[data-v-d1aa70fe] {\n  width: 800px;\n  height: 600px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
